// extracted by mini-css-extract-plugin
export default {"wrapper":"GD-z","response":"HD-z","error":"ID-z","disabled":"JD-z","buttons":"KD-z","feedbackQuestionSection":"LD-z","yesNoWrapper":"MD-z"};